import { Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './state/AppContext';
import AppLayout from './layouts/AppLayout';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Whistleblower from './pages/Whistleblower';

import Dashboard from './pages/app/Dashboard';
import Rfq from './pages/app/Rfq';
import BidCompare from './pages/app/BidCompare';
import Award from './pages/app/Award';
import Doa from './pages/app/Doa';
import Po from './pages/app/Po';
import PoDetail from './pages/app/PoDetail';
import Invoice from './pages/app/Invoice';
import Match from './pages/app/Match';
import Incoming from './pages/app/Incoming';
import Exec from './pages/app/Exec';
import Fraud from './pages/app/Fraud';
import Audit from './pages/app/Audit';
import MyBoard from './pages/app/MyBoard';
import Whpo from './pages/app/Whpo';
import Asl from './pages/app/Asl';
import Review from './pages/app/Review';
import SupplierDetail from './pages/app/SupplierDetail';
import BidSubmit from './pages/app/BidSubmit';
import MyOrders from './pages/app/MyOrders';
import Feedback from './pages/app/Feedback';
import Contract from './pages/app/Contract';
import ContractDetail from './pages/app/ContractDetail';
import Users from './pages/app/Users';
import Settings from './pages/app/Settings';
import Notifs from './pages/app/Notifs';
import Override from './pages/app/Override';
import Rpt from './pages/app/Rpt';
import Network from './pages/app/Network';
import WbCases from './pages/app/WbCases';
import Batch from './pages/app/Batch';
import InsCompare from './pages/app/InsCompare';
import BidForm from './pages/app/BidForm';
import Reports from './pages/app/Reports';
import ReviewDetail from './pages/app/ReviewDetail';
import SupplierPoDetail from './pages/app/SupplierPoDetail';
import WarehousePoDetail from './pages/app/WarehousePoDetail';
import RfqSend from './pages/app/RfqSend';
import BidDetail from './pages/app/BidDetail';

export default function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/report" element={<Whistleblower />} />

        <Route path="/app" element={<AppLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="rfq" element={<Rfq />} />
          <Route path="rfq/bid-comparison" element={<BidCompare />} />
          <Route path="rfq/award" element={<Award />} />
          <Route path="doa" element={<Doa />} />
          <Route path="po" element={<Po />} />
          <Route path="po/detail" element={<PoDetail />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="invoice/match" element={<Match />} />
          <Route path="incoming" element={<Incoming />} />
          <Route path="incoming/send" element={<RfqSend />} />
          <Route path="executive" element={<Exec />} />
          <Route path="fraud" element={<Fraud />} />
          <Route path="fraud/override" element={<Override />} />
          <Route path="fraud/rpt" element={<Rpt />} />
          <Route path="fraud/network" element={<Network />} />
          <Route path="fraud/whistleblower" element={<WbCases />} />
          <Route path="audit" element={<Audit />} />
          <Route path="portal/dashboard" element={<MyBoard />} />
          <Route path="portal/bids" element={<BidSubmit />} />
          <Route path="portal/bids/submit" element={<BidForm />} />
          <Route path="portal/bids/detail" element={<BidDetail />} />
          <Route path="portal/orders" element={<MyOrders />} />
          <Route path="portal/orders/detail" element={<SupplierPoDetail />} />
          <Route path="portal/feedback" element={<Feedback />} />
          <Route path="warehouse/po" element={<Whpo />} />
          <Route path="warehouse/po/detail" element={<WarehousePoDetail />} />
          <Route path="suppliers/asl" element={<Asl />} />
          <Route path="suppliers/review" element={<Review />} />
          <Route path="suppliers/review/detail" element={<ReviewDetail />} />
          <Route path="suppliers/detail" element={<SupplierDetail />} />
          <Route path="contracts" element={<Contract />} />
          <Route path="contracts/detail" element={<ContractDetail />} />
          <Route path="reports" element={<Reports />} />
          <Route path="users" element={<Users />} />
          <Route path="settings" element={<Settings />} />
          <Route path="notifications" element={<Notifs />} />
          <Route path="insurance-batch" element={<Batch />} />
          <Route path="insurance-batch/compare" element={<InsCompare />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppProvider>
  );
}
